import request from '@/util/request'
import Event from '@/util/proto/event'
import { wgs2gcjBatch } from '@/util/map'
import { distance , isCircleInRing } from '@/components/sl-amap/utils'

const latlng = (obj) => new AMap.LngLat(obj.lng , obj.lat)

const latlngsFrom = (arr) => arr.map( i => latlng(i) )

const boundsFrom = arr => new AMap.Bounds(...latlngsFrom(arr)) 

const toGeom = (data) => {
  let geometry = {
    type: data.category,
    coordinates:wgs2gcjBatch(data.points || [])
  }

  if( data.category == 1){
    geometry.radius = data.radius
  }
  else if( data.category == 2 && geometry.coordinates.length == 2){
    geometry.type = 3
  }

  return geometry
}

/*
{ value: 0, label: '禁行区围栏' }
{ value: 2, label: '工作区围栏' }
{ value: 3, label: '停放区围栏' }
*/
const getStyle = (type) => {
  const defaultTheme = { 2:'#4bd3b7' , 0:'#ed4014', 3:'#2db7f5' }
  if( type === undefined ) type = 2
  let color = defaultTheme[type]
  return {
    strokeColor: color,
    strokeOpacity: 0.8,
    strokeWeight: 1,
    fillColor: color,
    fillOpacity: 0.15,
    strokeStyle: 'solid',
  }
}

const rect2path = (p) => {
   let [a , b] = p
   return [
    [ a.lng , a.lat ] , [ a.lng , b.lat ],
    [ b.lng , b.lat ] , [ b.lng , a.lat ]
  ]
}

const p2path = (p) => p.map(i => ([i.lng , i.lat]))

const compareDeep = (a , b) => {
  // convert rect to polygon
  let ac = a.points.length == 2 ? rect2path(a.points) : p2path(a.points)
  let bc = b.points.length == 2 ? rect2path(b.points) : p2path(b.points)

  // circle vs circle
  if(a.category == 1 && b.category == 1){
    let dst = distance(ac[0] , bc[0])
    //不相交
    if(dst > (a.radius + b.radius)){
      return 0
    }else{
      return a.radius >= b.radius ? 1 : -1
    }
  }
  // circle vs polygon
  else if(a.category == 1 && b.category != 1){
    if( isCircleInRing(ac[0] , a.radius , bc) ){
      return 1
    }else{
      return -1
    }
  }
  // polygon vs circle
  else if(a.category !=1 && b.category == 1){
    if( isCircleInRing(bc[0] , b.radius , ac) ){
      return -1
    }else{
      return 1
    }
  }
  // polygon vs polygon
  else {
    // b contain a
    if(AMap.GeometryUtil.isRingInRing(ac , bc)){
      return -1
    }else if(AMap.GeometryUtil.isRingInRing(bc , ac)){
      return 1
    }else{
      return 0
    }
  }
}

class FenceLayer extends Event{
  constructor(){
    super()

    this.map = null
    this.data = []
    this.overlays = {}

    this.activeOverlay = null
  }

  setMap(map){
    if( map === null ){
      this.clear()
    }else{
      this.map = map
      this.query()
    }
  }

  query(){
    request.fencesView().then(resp => {
      console.log(resp)
      this.data = resp.data.list || []
      this.render()
    })
  }
  render(){
    //排序
    for(let i of this.data.sort(compareDeep)) this.add(i)
  }
  add(d){
    let { type, coordinates, radius } = toGeom(d)
    let options = {
      map: this.map,
      zIndex:100,
      extData:d,
      ...getStyle(d.gfType)
    }
    let overlay

    if (type == 1) {
      overlay = new AMap.Circle({
        center: latlng(coordinates[0]),
        radius: radius,
        ...options
      })
    } else if (type == 3) {
      overlay = new AMap.Rectangle({
        bounds: boundsFrom(coordinates),
        ...options
      })
    } else if (type == 2) {
      overlay = new AMap.Polygon({
        path: latlngsFrom(coordinates),
        ...options
      })
    }

    overlay.setMap(this.map)

    overlay.on('click' , this.handleClick , this)

    this.map.setFitView(null, true)

    this.overlays[d.id] = overlay
  }

  remove(overlay){
    overlay.setMap(null)
  }
  clear(){
    for(let i in this.overlays){
      this.remove( this.overlays[i] )
      delete this.overlays[i]
    }
  }
  handleClick(e){
    let data = e.target.getExtData()
    this.trigger('click' , data)
    //this.focus( data.id )
  }

  focus( id ){
    if( this.activeOverlay){
      let last = this.overlays[this.activeOverlay]
      if( last ){
        last.setOptions({strokeWeight:1 ,strokeOpacity:0.8})
      }
    }
    if( id ){
      this.activeOverlay = id
      this.overlays[id].setOptions({strokeWeight:5 ,strokeOpacity:0.6})
    }else{
      this.activeOverlay = null
    }
  }

  destroy() {
    this.clear()
    this.overlays = {}
    this.data = []
  }
}

export default FenceLayer